import styled from 'styled-components';

import { SVG_COLOR } from './constants';

export const IconWrap = styled.div`
  margin-right: 2rem;
  width: 3.125rem;

  > svg {
    height: 2.5rem;
    fill: ${SVG_COLOR};
  }
`;

export default IconWrap;
